import jsPDF from 'jspdf';
import 'jspdf-autotable';

export default {
	methods: {
		printPagamento(item) {
			item.usuario = item.frota ? item.motorista : item.nome;
			item.cpf = item.frota ? item.cpf_motorista : item.cpf_placa;
			let type = item.frota ? 'Frota' : 'Convênio';

			var doc = new jsPDF();
			primeiraVia(doc, type, item);
			segundaVia(doc, type, item);

			doc.autoPrint();
			window.open(URL.createObjectURL(doc.output('blob')), '_blank');
		},
	},
};

function segundaVia(doc, type, item) {
	doc.setFontStyle('bold');
	doc.setFontSize(10);
	doc.text('POP CARD ' + type, 4, 120);
	doc.setFontStyle('normal');
	doc.text('Comprovante de Pagamento', 4, 125);
	doc.setFontSize(9);
	doc.text(item.data_pagamento, 4, 130);
	doc.text('Fornecedor:', 4, 138);
	doc.text(capitalize(item.fornecedor), 4, 142);
	doc.text('Código da Venda: ' + item.id, 4, 147);
	doc.text('Valor: ' + item.valor, 4, 152);
	doc.text('Parcelas: ' + item.parcelas, 4, 157);
	doc.text('-------------------------------------------------', 4, 170);
	doc.text(capitalize(item.usuario), 4, 175);
	doc.text('CPF: ' + item.cpf, 4, 180);
	//return;
	doc.text(capitalize(item.empresa), 4, 185);
	if (item.frota) {
		doc.text('Placa: ' + item.cpf_placa.toUpperCase(), 4, 190);
	}
}

function primeiraVia(doc, type, item) {
	doc.setFontStyle('bold');
	doc.setFontSize(10);
	doc.text('POP CARD ' + type, 4, 20);
	doc.setFontStyle('normal');
	doc.text('Comprovante de Pagamento', 4, 25);
	doc.setFontSize(9);
	doc.text(item.data_pagamento, 4, 30);
	doc.text('Fornecedor:', 4, 38);
	doc.text(capitalize(item.fornecedor), 4, 42);
	doc.text('Código da Venda: ' + item.id, 4, 47);
	doc.text('Valor: ' + item.valor, 4, 52);
	doc.text('Parcelas: ' + item.parcelas, 4, 57);
	doc.text('-------------------------------------------------', 4, 70);
	doc.text(capitalize(item.usuario), 4, 75);
	doc.text('CPF: ' + item.cpf, 4, 80);
	doc.text(capitalize(item.empresa), 4, 85);
	if (item.frota) {
		doc.text('Placa: ' + item.cpf_placa.toString().toUpperCase(), 4, 90);
	}
}

function capitalize(str) {
	return str.replace(/\w\S*/g, function(txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}
